import { useEffect, useState } from 'react';
import { useForm } from 'react-hook-form';
import { useNavigate } from 'react-router-dom';
import { useParams } from 'react-router-dom';
import SweetAlertService from '../../../services/SweetAlertService';
import { errorMessages, getMaxLengthErrorMessage, getRequiredErrorMessage, jobCategoryNameMaxLength, jobCategoryActivityNamePattern, errorMessagesForSubRoleSelection } from '../Shared/Constants/AdminModuleConstants';
import JobCategoryService from '../Shared/Services/JobCategoryService';
import { SubRole } from './models/JobCategory';

export const UpdateJobCategory = () => {
    const navigate = useNavigate();
    const { id } = useParams();
    const [subRoles, setSubRoles] = useState<SubRole[]>([]);
    const [selectedSubRoles, setSelectedSubRoles] = useState<number[]>([]);
    const { register, handleSubmit, setValue, reset, formState: { errors } } = useForm();
    //const [showJobPlan, setShowJobPlan] = useState(false);

    useEffect(() => {
        loadSubRoles();
        getJobCategoryById();
    }, []);

    const loadSubRoles = async () => {
        try {
            const response = await JobCategoryService.getAllSubRoles();
            setSubRoles(response?.data);
        } catch (error) {
            SweetAlertService.error("Error", "Error loading subroles");
        }
    };

    const handleSubRoleChange = (subRoleId: number, isChecked: boolean) => {
        if (isChecked) {
            setSelectedSubRoles([...selectedSubRoles, subRoleId]);
        } else {
            setSelectedSubRoles(selectedSubRoles.filter(id => id !== subRoleId));
        }
    };

    const getJobCategoryById = () => {
        JobCategoryService.getJobCategoryById(Number(id)).then((res: any) => {
            setValue('name', res.data.name);
            setValue('shortName', res.data.shortName);
            setValue('isCountToSession', res.data.isCountToSession.toString());
            //setValue('isMandatoryInJobPlan', res.data.isMandatoryInJobPlan.toString());
            setValue('isDefaultInWorkActivity', res.data.isDefaultInWorkActivity.toString());
            //setValue('isInJobPlan', res.data.isInJobPlan.toString());
            //setShowJobPlan(!res.data.isDefaultInJobPlan);
            setSelectedSubRoles(res.data.assignedSubRoleIds || []);
        }).catch((erorr) => {
            SweetAlertService.error("Error", `Error : Something went wrong while getting job category by id ${id}`);
        })
    };

    const onSubmit = (data: any) => {
        data.name = data.name.trim();
        data.shortName = data.shortName.trim();
        data.id = id;
        data.isCountToSession = data.isCountToSession == 'true';
        data.isDefaultInWorkActivity = data.isDefaultInWorkActivity == 'true';
        //data.isInJobPlan = data.isInJobPlan == 'true';
        //data.isMandatoryInJobPlan = data.isMandatoryInJobPlan == 'true';
        data.subRoleIds = selectedSubRoles;
        JobCategoryService.updateJobCategory(Number(id), data).then((res) => {
            if (res) {
                navigate("/jobcategory");
            }
            reset();
        }).catch(error => {
            const errorMessage = error?.response?.data?.errors?.Name?.[0] || error?.response?.data?.errors?.Id?.[0];
            if (errorMessage) {
                SweetAlertService.error("Error", errorMessage);
            }
        })
    };

    //const hideIsInJobPlan = (e: any) => {
    //    e == 'false' ? setShowJobPlan(true) : setShowJobPlan(false);
    //}

    return (
        <div className="card card-default">
            <div className="card-header">
                <h4>Edit Job category</h4>
            </div>
            <div className="card-body">
                <form onSubmit={handleSubmit(onSubmit)}>
                    <div className="form-group row">
                        <label className="col-sm-3 control-label">Name</label>
                        <div className="col-sm-9">
                            <input
                                type="text"
                                className="form-control"
                                {...register("name", {
                                    required: getRequiredErrorMessage("Name"),
                                    maxLength: {
                                        value: jobCategoryNameMaxLength,
                                        message: getMaxLengthErrorMessage(jobCategoryNameMaxLength)
                                    },
                                    pattern: {
                                        value: jobCategoryActivityNamePattern,
                                        message: errorMessages.pattern
                                    },
                                })}
                            />
                            {errors.name && (
                                <span className="help-block m-b-none text-danger field-validation-valid">
                                    {errors.name.message?.toString()}
                                </span>
                            )}
                        </div>
                    </div>
                    <br/>
                    <div className="form-group row">
                        <label className="col-sm-3 control-label">Short Name</label>
                        <div className="col-sm-9">
                            <input
                                type="text"
                                className="form-control"
                                {...register("shortName", {
                                    required: getRequiredErrorMessage("Short Name"),
                                    maxLength: {
                                        value: jobCategoryNameMaxLength,
                                        message: getMaxLengthErrorMessage(jobCategoryNameMaxLength)
                                    },
                                    pattern: {
                                        value: jobCategoryActivityNamePattern,
                                        message: errorMessages.pattern
                                    }
                                })}
                            />
                            {errors.shortName && (
                                <span className="help-block m-b-none text-danger field-validation-valid">
                                    {errors.shortName.message?.toString()}
                                </span>
                            )}
                        </div>
                    </div>
                    <br/>
                    <div className="form-group row">
                        <label className="col-sm-3 control-label">Count To Sessions</label>
                        <div className="col-sm-9">
                            <div className="d-flex flex-row">
                                <input
                                    value="true"
                                    type="radio"
                                    {...register("isCountToSession")}
                                />
                                Yes
                                <input className="ms-3"
                                    value="false"
                                    type="radio"
                                    {...register("isCountToSession")}
                                />No
                            </div>
                        </div>
                    </div>
                    <br />
                    {/*<div className="form-group row">*/}
                    {/*    <label className="col-sm-3 control-label">Is Mandatory In Job Plan</label>*/}
                    {/*    <div className="col-sm-9">*/}
                    {/*        <div className="d-flex flex-row">*/}
                    {/*            <input*/}
                    {/*                value="true"*/}
                    {/*                type="radio"*/}
                    {/*                {...register("isMandatoryInJobPlan")}*/}
                    {/*            />*/}
                    {/*            Yes*/}
                    {/*            <input className="ms-3"*/}
                    {/*                value="false"*/}
                    {/*                type="radio"*/}
                    {/*                {...register("isMandatoryInJobPlan")}*/}
                    {/*            />No*/}
                    {/*        </div>*/}
                    {/*    </div>*/}
                    {/*</div>*/}
                    {/*<br/>*/}
                    <div className="form-group row">
                        <label className="col-sm-3 control-label">Is Default In WorkActivity</label>
                        <div className="col-sm-9">
                            <div className="d-flex flex-row">
                                <input
                                    value="true"
                                    type="radio"
                                    {...register("isDefaultInWorkActivity")}
                                />
                                Yes
                                <input className="ms-3"
                                    value="false"
                                    type="radio"
                                    {...register("isDefaultInWorkActivity")}

                                />No
                            </div>
                        </div>
                    </div>
                    <br />
                    {/*{*/}
                    {/*    showJobPlan &&*/}
                    {/*    <div className="form-group row">*/}
                    {/*        <label className="col-sm-3 control-label">Is In Job Plan</label>*/}
                    {/*        <div className="col-sm-9">*/}
                    {/*            <div className="d-flex flex-row">*/}
                    {/*                <input*/}
                    {/*                    value="true"*/}
                    {/*                    type="radio"*/}
                    {/*                    {...register("isInJobPlan")}*/}
                    {/*                />*/}
                    {/*                Yes*/}
                    {/*                    <input className="ms-3"*/}
                    {/*                    value="false"*/}
                    {/*                    type="radio"*/}
                    {/*                    {...register("isInJobPlan")}*/}
                    {/*                />No*/}
                    {/*            </div>*/}
                    {/*        </div>*/}
                    {/*    </div>*/}
                    {/*}*/}
                    {/*<br/>*/}
                    <div className="form-group row">
                        <label className="col-sm-3 control-label">Assign Roles</label>
                        <div className="col-sm-9">
                            <div className="d-flex flex-column">
                                <input
                                    type="hidden"
                                    {...register("subRoleIds", {
                                        validate: () => selectedSubRoles?.length > 0 ? true : errorMessagesForSubRoleSelection
                                    })}
                                    value={selectedSubRoles.join(',')}
                                />
                                {subRoles.map((subRole) => (
                                    <div key={subRole?.id} className="form-check">
                                        <input
                                            className="form-check-input"
                                            type="checkbox"
                                            id={`subRole_${subRole?.id}`}
                                            checked={selectedSubRoles.includes(subRole?.id)}
                                            onChange={(e) => handleSubRoleChange(subRole?.id, e?.target?.checked)}
                                        />
                                        <label className="form-check-label" htmlFor={`subRole_${subRole?.id}`}>
                                            {subRole?.name}
                                        </label>
                                    </div>
                                ))}
                            </div>
                            {errors?.subRoleIds && (
                                <span className="help-block m-b-none text-danger field-validation-valid">
                                    {errors?.subRoleIds?.message?.toString()}
                                </span>
                            )}
                        </div>
                    </div>
                    <br />
                    <div className="form-group row">
                        <div className=" col-sm-offset-3">
                            <a className="btn btn-secondary" onClick={() => navigate('/jobcategory')}>
                                Back
                            </a>
                            <button className="btn btn-primary ms-1" type="submit" >
                                Save
                            </button>
                        </div>
                    </div>
                </form>
            </div>
        </div>
    )
}
export default UpdateJobCategory;